import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Globe } from 'lucide-react';
import './Employeetype.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const EditEmployeetype = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: ""
  });

  useEffect(() => {
    const fetchEmployeetype = async () => {
      try {
        const response = await axios.get(`${url}/api/employeetype/${id}`);
        setData({
          name: response.data.data.name
        
        });
      } catch (error) {
        toast.error("Failed to load Employeetype data");
        navigate('/ViewEmployeetype');
      }
    };

    fetchEmployeetype();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(
        `${url}/api/employeetype/${id}`,
        data
      );

      if (response.data.success) {
        toast.success("Employeetype updated successfully!");
        navigate('/ViewEmployeetype');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update Employeetype");
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">
          <Globe size={20} className="inline mr-2" /> Edit Employeetype
        </h2>
        
        <form className="country-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={handleChange}
              required
            />
            <label>Employee Type</label>
          </div>


          <div className="button-group">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/ViewEmployeetype')}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update Employeetype"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployeetype;